import { useTreeStateContext } from "../../contexts/TreeContext";
function usePathFilter() {

    const { paths } = useTreeStateContext();
    
    const filterPathsVisible = (blocks) => {
        let pathsVisible = [];

        // First loop to get all the paths visible (in & out) on each blocks
        for(var j = 0; j < paths.length; j++) {
            var path = paths[j];

            for(var i = 0; i < blocks.length ; i++) {
                let block = blocks[i];

                // Paths In
                if(path.parent_block_id == block.object_id) {
                    pathsVisible.push(path);
                }

                // Skip block jump (only block's jump doesn't have children)
                if(block.children == undefined) {
                    continue;
                }

                // Paths out
                for(var h = 0; h < block.children.length; h++ ) {
                    let child = block.children[h];
                    if(child.object_id == path.child_block_id) {
                        pathsVisible.push(path);
                    }
                }
            }
        }
        
        let pathsVisibleWithoutDouble = [];
        // Second loop to remove path who has been find multiple time (in & out)
        for(var i = 0; i < pathsVisible.length; i++) {
            var path = pathsVisible[i];
            var found = false;
        
            for(var j = 0; j < pathsVisibleWithoutDouble.length; j++) {
                if(pathsVisibleWithoutDouble[j].path_id == path.path_id) {
                    found = true;
                    break;
                }
            }

                
            if(!found) {
                pathsVisibleWithoutDouble.push(path);
            }
                
        }
        return pathsVisibleWithoutDouble
    }

    return { filterPathsVisible }
}

export default usePathFilter;